import config from "@/common/config";

import ApiService from "./api.service";

export default {
  VERSION: config.api.versions.v2,

  /**
   * @param {string} packageGroup
   * @param {string} level
   * @param {string|null} language
   */
  updateLanguageLevel(packageGroup, level, language = null) {
    return ApiService.post(
      `user/settings/${packageGroup}/language-levels`,
      { level, language },
      this.VERSION
    );
  },

  /**
   * @param {string} packageGroup
   */
  resetAllLevels(packageGroup) {
    return ApiService.delete(`user/settings/${packageGroup}/language-levels`, this.VERSION);
  }
};
